var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.latestNotifications),function(latestNotification){return _c('latest-notification',{key:latestNotification.id,attrs:{"latest-notification":latestNotification,"view-route":_vm.baseRoute + '/' + latestNotification.id,"mark-as-read-string":_vm.markAsReadString,"read-notifications":_vm.readNotifications}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }